export default {
    state: {
        extrato: {},
        financialMedia: {
            name: 'Média de Gasto',
            format: 'currency',
            value: '--'
        }
    },
    mutations: {
        setFinancialMedia (state, data) {
            state.financialMedia.value = data
        },
        setFinancialData (state, data) {
            state.extrato = data
        }
    },
    actions: {
        setFinancialMedia ({ commit }, data) {
            commit('setFinancialMedia', data)
        },
        setFinancialData ({ commit }, data) {
            commit('setFinancialData', data)
        }
    },
    getters: {
        getFinancialMedia: (state) => state.financialMedia,
        getExtrato: (state) => state.extrato
    }
}
